export const colors = {
  gray: {
    dark: "#212121",
    medium: "#666666",
    light: "#E0E0E0",
  },
  pink: {
    50: "#FDF2F8",
    100: "#FCE7F3",
    200: "#FBCFE8",
    300: "#F9A8D4",
    400: "#F472B6",
    500: "#EC4899",
    600: "#DB2777",
    700: "#BE185D",
    800: "#9D174D",
    900: "#831843",
  },
  stone: {
    50: "#FAFAF9",
    100: "#F5F5F4",
    200: "#E7E5E4",
    300: "#D6D3D1",
    400: "#A8A29E",
    500: "#78716C",
    600: "#57534E",
    700: "#44403C",
    800: "#292524",
    900: "#1C1917",
  },
  red: {
    50: "#FEF2F2",
    100: "#FEE2E2",
    200: "#FECACA",
    300: "#FCA5A5",
    400: "#F87171",
    500: "#EF4444",
    600: "#DC2626",
    700: "#B91C1C",
    800: "#991B1B",
    900: "#7F1D1D",
  },
  yellow: {
    50: "#FFFBEB",
    100: "#FEF3C7",
    200: "#FDE68A",
    300: "#FCD34D",
    400: "#FBBF24",
    500: "#F59E0B",
    600: "#D97706",
    700: "#B45309",
    800: "#92400E",
    900: "#78350F",
  },
  green: {
    50: "#ECFDF5",
    100: "#D1FAE5",
    200: "#A7F3D0",
    300: "#6EE7B7",
    400: "#34D399",
    500: "#10B981",
    600: "#059669",
    700: "#047857",
    800: "#065F46",
    900: "#064E3B",
  },
  black: "#171717",
  white: "#FFFFFF",

  orange: {
    500: "#F97316",
  },
  teal: {
    500: "#14B8A6",
  },
  cyan: {
    500: "#06B6D4",
  },
  lightBlue: {
    500: "#0EA5E9",
  },
  blue: {
    500: "#2D9CDB",
  },

  background: "#E5E5E5",
};

export const languageColors = {
  JavaScript: "#F2C94C",
  Ruby: "#701516",
  Python: "#3572A5",
  TypeScript: "#2b7489",
  Java: "#b07219",
  Kotlin: "#F18E33",
  "C#": "#178600",
  Dart: "#00B4AB",
  HTML: "#e34c26",
  CSS: "#563d7c",
  Go: "#00ADD8",
  Shell: "#89e051",
  elixir: "#6e4a7e",
};
